export default {
  displayNoMatch(state, payload) {
    return (state.noMatch = payload);
  },
  getAllRocks(state, payload) {
    return (state.results = payload);
  },
  getPageTitle(state, payload) {
    return (state.currentTitle = state.title[payload]);
  },
  getOneRock(state, payload) {
    return (state.oneRock = payload);
  },
  getQuerySuggestions(state, payload) {
    return (state.querySuggestions = payload);
  },
  getRockNames(state, payload) {
    return (state.rockNames = payload);
  },
};
